<!-- eslint-disable -->
<template lang="pug">
    cs-loader(v-if="isLoading")
    .battle-form__body(v-else-if="isCreator")
        .battle-form__block
            .battle-form__label_long
                | {{ $i18n.t('battle.battle_battleForm_trainingBattleName') }}
            .battle-form__block-body
                cs-input.battle-form__input(
                    v-model="form.name",
                    v-validate="'required'",
                    :data-vv-as="$i18n.t('battle.battle_battleForm_trainingBattleName')",
                    name="battle-name"
                )
                help-text(error, slot="help-text", v-if="errors.has('battle-name')")
                    | {{ errors.first('battle-name') }}
        hr.battle-form__divider
        .battle-form__block
            .battle-form__label
                | {{$i18n.t('olympiads.olympiads_olympiadForm_cover') }}
            .battle-form__block-body
                cs-image-input(
                    v-model="form.logo",
                    type="battle",
                    @showSizeError="showSizeError",
                    :loadText="$i18n.t('profiles.profiles_common_uploadImage')",
                    :removeText="$i18n.t('profiles.profiles_common_removeImage')"
                    :helpText="$i18n.t('common.common_imageInput_sizeHelpText')",
                    :error="showImageWarning ? imageWarningText : ''"
                    :crop="false"
                )
        template(v-for="(level, index) in form.levels")
            hr.battle-form__divider
            .battle-form__block-group
                .battle-level__title
                .battle-level__grid
                    .battle-level__grid-col
                        .battle-form__block.battle-form__block-for-group(v-if="courses.length > 1")
                            .battle-form__label
                                | {{ $i18n.t('olympiads.olympiads_olympiadForm_course') }}
                            .battle-form__block-body
                                cs-multiselect(
                                    :options="courses",
                                    @input="onCourseChangeHandler(level, $event)",
                                    :value="level.course",
                                    :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                                    :multiple="false",
                                    :allowEmpty="false",
                                    :hide-selected="true",
                                    label="name",
                                    trackBy="id"
                                    v-validate="'required'"
                                    :data-vv-as="$i18n.t('olympiads.olympiads_olympiadForm_course')",
                                    :name="`courses${index}`"
                                )
                                help-text(error, slot="help-text", v-if="errors.has(`courses${index}`)")
                                    | {{ errors.first(`courses${index}`) }}
                        .battle-form__block.battle-form__block-for-group
                            .battle-form__label
                                | {{ $i18n.t('olympiads.olympiads_olympiadForm_theme') }}
                            .battle-form__block-body
                                cs-input.battle-form__input(
                                    v-model="level.theme",
                                    v-validate="'required'",
                                    :data-vv-as="$i18n.t('olympiads.olympiads_olympiadForm_theme')",
                                    :name="'theme' + index"
                                )
                                help-text(error, slot="help-text", v-if="errors.has('theme' + index)")
                                    | {{ errors.first('theme' + index) }}
                        .battle-form__block.battle-form__block-for-group
                            .battle-form__label
                                | {{ $i18n.t('olympiads.olympiads_olympiadForm_length') + ':' }}
                            .battle-form__block-body
                                .input-group
                                    .input-group__col
                                        cs-input.battle-form__input(
                                            v-model.number="level.duration",
                                            type="number",
                                            v-validate="'required|min_value:1'",
                                            :data-vv-as="$i18n.t('olympiads.olympiads_olympiadForm_length')",
                                            :name="'duration' + index"
                                        )
                                    .input-group__col.input-group__col--narrow
                                        | {{ $i18n.tc('olympiads.olympiads_timeDeclination_minutes', level.duration) }}
                                help-text(error, slot="help-text", v-if="errors.has('duration' + index)")
                                    | {{ errors.first('duration' + index) }}
                        .battle-form__block.battle-form__block-for-group
                            .battle-level-settings
                                .battle-level-settings__button-container
                                    cs-button.battle-level-settings__button(
                                        type="button"
                                        pattern="primary-outline",
                                        color="blue",
                                        @click="editLevel(index)",
                                        :disabled="!level.course"
                                    )
                                        svg-icon.battle-level-settings__button-item(name="cog")
                                        =" "
                                        span.battle-level-settings__button-item
                                            | {{ $i18n.t('olympiads.olympiads_olympiadForm_set') }}
                                .battle-level-settings__parameters(v-if="areSettingsNotAvailable(level)")
                                    svg-icon.battle-level-settings__parameters-icon(name="exclamation-circle")
                                    span.battle-level-settings__parameters-text
                                        | {{ $i18n.t('olympiads.olympiads_olympiadForm_setParameters') }}
        hr.battle-form__divider
        .battle-form__block.battle-form__button-group
            cs-button.battle-form__button(pattern="primary-outline", color="blue", @click="$router.back()")
                | {{ $i18n.t('common.common_button_cancel') }}
            cs-button.battle-form__button(
                color="blue"
                @click="sendForm",
                :disabled="isLoading"
                :loading="isLoading"
            )
                | {{ $i18n.t('olympiads.olympiads_olympiadForm_publish') }}
    .battle-form__body(v-else)
        | {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
</template>

<script>
    /*eslint-disable*/
    import BattleApi from '../../../api/battle';

    import _ from 'lodash';
    import levelTemplate from '../config/levelTemplate.json';
    import stageTemplate from '../config/stageTemplate.json';
    import moment from 'moment';
    import { mapState } from 'vuex';
    import getBase64FromUrl from '../../../utils/getBase64FromUrl';
    import PaymentServicesApi from '../../../api/billing/paymentServices';

    const AVAILABLE_COURSES = ['mental-arithmetic', 'russian-language'];

    export default {
        props: ['id'],
        mixins: [getBase64FromUrl],
        data() {
            return {
                levelTemplate,
                allCourses: [],
                schools: [],
                grades: [],
                students: [],
                paymentServices: [],
                form: {
                    name: '',
                    creatorId: 1,
                    schools: [],
                    grades: [],
                    students: [],
                    start: null,
                    end: null,
                    logo: null,
                    paymentService: null,
                    price: 0,
                    currency: 'RUB',
                    levels: [],
                    termsOfUseLink: 'http://cleverstart.ru/soglashenie/',
                    rulesLink: 'http://cleverstart.ru/',
                },
                isLoading: false,
                imageWarningText: '',
                showImageWarning: false,
            };
        },
        mounted() {
            this.getPaymentServices();
            if (this.id && !this.battle) {
                this.isLoading = true;
                BattleApi.show(this.id, { course_type: _.kebabCase(this.course) })
                    .then(battle => {
                        this.form = _.cloneDeep(battle);
                        this.form.levels.forEach(level => {
                            level.stages.forEach(stage => {
                                stage.games.forEach(game => {
                                    if (game.slug === 'Puzzle') {
                                        this.assignImageForPuzzleGame(game);
                                        game.parameters.default.isImageChanged = false;
                                    }
                                });
                            });
                        });
                        if (battle.start) {
                            this.form.start = this.dateToMoment(battle.start, 'YYYY-MM-DDThh:mm:ss');
                        }
                        if (battle.end) {
                            this.form.end = this.dateToMoment(battle.end, 'YYYY-MM-DDThh:mm:ss');
                        }
                        this.isLoading = false;
                    })
                    .catch(err => {
                        err = err.response && err.response.data ? err.response.data : err;
                        if (err && (err.status_code === 403 || err.status_code === 404)) {
                            this.$toasted.error(this.$root.$t(`errors.${err.message}`));
                        }
                    });
            } else if (!this.form.levels[0]) {
                this.addLevel();
            }
            this.form.creatorId = this.user.id;
        },
        watch: {
            battle: {
                handler(newBattle) {
                    if (newBattle) {
                        this.form = newBattle;
                    }
                },
                immediate: true,
            },
            'form.logo': {
                handler(val) {
                    if (val) {
                        this.showImageWarning = false;
                        this.imageWarningText = '';
                    }
                },
            },
        },
        methods: {
            async assignImageForPuzzleGame(game) {
                game.parameters.default.image = await this.getBase64ImageFromUrl(
                    this.$options.filters.apiFile(game.parameters.default.imageSrc)
                );
            },
            dateToMoment(date, format) {
                this.$nextTick(() => {
                    this.$validator.validate('start');
                    this.$validator.validate('end');
                });
                return moment(date).format(format);
            },
            areSettingsNotAvailable(level) {
                for (let stage of level.stages) {
                    if (stage.games.length === 0) {
                        return true;
                    }
                }
                return false;
            },
            editLevel(index) {
                this.$store.dispatch('setBattle', this.form);
                this.$router.push({
                    name: 'battle-training-level:create',
                    params: {
                        index: index,
                        battleId: this.id,
                    },
                });
            },
            resetDates() {
                this.form.start = null;
                this.form.end = null;
            },
            optimizeForm(form) {
                form.students = form.students.map(student => student.id);
                form.grades = form.grades.map(grade => grade.id);
                form.schools = form.schools.map(school => school.id);
                form.levels = form.levels.map(level => {
                    level.stages.forEach(stage => {
                        stage.startTime = null;
                        stage.endTime = null;
                    });
                    level.students = level.students.length ? level.students.map(student => student.id) : [];
                    level.grades = level.grades.length ? level.grades.map(grade => grade.id) : [];
                    level.schools = level.schools.length ? level.schools.map(school => school.id) : [];
                    level.course_id = level.course.id;
                    return level;
                });
                form.paymentService = form.paymentService.id;
                if (!form.logo) {
                    delete form.logo;
                }
            },
            sendForm() {
                if (_.isEmpty(this.form.levels)) {
                    this.$toasted.info(this.$i18n.t('olympiads.olympiads_olympiadForm_atLeastOne'));
                    return;
                }
                for (let level of this.form.levels) {
                    if (this.areSettingsNotAvailable(level)) {
                        this.$toasted.info(this.$i18n.t('olympiads.olympiads_olympiadForm_setToContinue'));
                        return;
                    }
                }
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.isLoading = true;
                        let form = _.cloneDeep(this.form);
                        this.optimizeForm(form);
                        this.sendRequest(form)
                            .then(response => {
                                this.isLoading = false;
                                this.$store.dispatch('setBattle', null);
                                this.$router.push({ name: 'battle-trainings:index' });
                            })
                            .catch(err => {
                                this.isLoading = false;
                                err = err.response && err.response.data ? err.response.data : err;
                                if (err && (err.status_code === 403 || err.status_code === 404)) {
                                    this.$toasted.error(this.$root.$t(`errors.${err.message}`));
                                }
                            });
                    } else {
                        this.$toasted.info(this.$i18n.t('errors.fill_form'));
                    }
                });
            },
            sendRequest(form) {
                return this.id ? BattleApi.update(this.id, form) : BattleApi.create(form);
            },
            addLevel() {
                let level = _.cloneDeep(levelTemplate);
                level.position = this.form.levels.length;
                this.courses.length === 1 && (level.course = this.courses[0]);
                this.form.levels.push(level);
            },
            onCourseChangeHandler(level, selected) {
                level.course = selected;
                level.stages = [_.cloneDeep(stageTemplate)];
            },
            getAnswerDurationHelper(index) {
                return this.errors.has('answerDuration' + index)
                    ? this.errors.first('answerDuration' + index)
                    : this.$i18n.t('olympiads.olympiads_olympiadForm_leaveTimeEmpty');
            },
            showSizeError() {
                this.imageWarningText = this.$i18n.t('trainer.trainer_gameFormSetting_imageWeightWarning');
                this.showImageWarning = true;
            },
            customFormatter(date, format = 'D MMM YYYY') {
                return moment(date).format(format);
            },
            getPaymentServices() {
                if (this.paymentServices.length) {
                    return;
                }
                this.loadingPaymentServices = true;
                PaymentServicesApi.list()
                    .then(data => {
                        this.paymentServices = data.data;
                        this.form.paymentService = this.paymentServices[0];
                        this.loadingPaymentServices = false;
                    })
                    .catch(err => {
                        this.loadingPaymentServices = false;
                        this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    });
            },
        },
        computed: {
            ...mapState({
                battle: state => state.battle.battle,
                user: state => state.auth.user,
                course: state => state.trainer.course,
            }),
            courses() {
                let courses = this.user.grades
                    .map(grade => grade.course)
                    .filter(({ type }) => AVAILABLE_COURSES.includes(type));
                if (this.user.type === 'student') {
                    const courseKebab = _.kebabCase(this.course);
                    courses = courses.filter(({ type }) => type === courseKebab);
                }
                return courses;
            },
            isCreator() {
                return this.form && this.user.id === this.form.creatorId;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .battle-form__body {
        width: 70%;
    }

    .battle-form__block {
        display: flex;
        padding-right: 10%;
        margin-bottom: 20px;
    }

    .battle-form__block-group {
        flex-direction: column;
    }

    .battle-form__block-for-group {
        padding-right: 5px;
    }

    .battle-form__label {
        min-width: 13em;
        font-size: 16px;
        line-height: 19px;
        text-align: right;
        margin-right: 20px;
        align-self: center;
        width: 35%;
        &_long {
            min-width: 13em;
            font-size: 16px;
            line-height: 19px;
            text-align: right;
            margin-right: 20px;
            align-self: center;
            width: 50%;
        }
    }

    .battle-form__label-datepicker {
        align-self: flex-start;
        margin-top: 5px;
    }

    .battle-form__block-body {
        flex-grow: 5;
        width: 65%;
    }

    .battle-form__input {
        margin-bottom: 0;
    }

    .battle-form__divider {
        border: 0;
        background: $hsl-color-gray-74;
        height: 1px;
        width: 100%;
        margin: 30px auto;
    }

    .battle-form__button {
        &:not(:last-child) {
            @include media($sm) {
                margin-right: 25px;
            }
        }
    }

    .battle-form__block--center,
    .battle-form__button-group {
        justify-content: center;
        padding-left: 40px;
    }

    .battle-level-settings {
        width: 100%;
        @include make-grid($space-small);
        @include make-offset(4, 12);
        @include stack-space($space-small);
        @include media($sm) {
            @include make-grid(0);
            @include make-offset(0, 12);
        }
        flex-direction: column;
        align-items: center;
    }

    .battle-level-settings__button-container {
        display: flex;
        justify-content: center;
    }

    .battle-level-settings__button {
        margin-bottom: 5px;
        display: block;
    }

    .battle-level-settings__button-item {
        vertical-align: middle;
    }

    .battle-level-settings__parameters {
        @include make-col(12, 12, $space-small);
        text-align: center;
        padding: 15px 0 0 30px;
    }

    .battle-level-settings__parameters-icon {
        vertical-align: middle;
        color: $hsl-color-red-62;
        @include inline-space($space-xx-small);
    }

    .battle-level-settings__parameters-text {
        vertical-align: middle;
        color: $hsl-color-gray-52;
    }

    .battle-level-settings__close-group {
        padding: 0 !important;
    }

    .battle-level__title {
        text-align: center;
        font-weight: 500;
        font-size: 22px;
        @include stack-space($space-base);
        padding-right: 10%;
    }

    .battle-level__grid {
        @include make-grid;
    }

    .battle-level__grid-col {
        @include make-col;
        padding-right: 0;
        width: 100%;
    }

    .battle-level__grid-col--narrow {
        flex: 0;
    }

    .battle-level__control-buttons {
        padding: 10px 25px;
    }

    .battle-level__circle-button {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        width: 2em;
        height: 2em;
        padding: 0;
        margin: 30px 0 0;
    }

    .input-group {
        @include make-grid;
        align-items: center;
        &--datepickers {
            margin-bottom: 20px;
        }
        &--divided {
            @include media($sm) {
                flex-direction: row;
            }
        }
        &__col {
            @include make-col;
            &--narrow {
                flex: 0;
            }
        }
    }
</style>
